import { render } from "./AIDemo.vue?vue&type=template&id=bed78c42&ts=true"
import script from "./AIDemo.vue?vue&type=script&lang=ts"
export * from "./AIDemo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__